import * as React from 'react';
import userflow from 'userflow.js';
import { OrgComponentProps } from '../../typescriptHelpers';
import { globalMessage } from '../../utils/globalMessage';
import { USERFLOW_TRIAL_PROMPT_FLOW_ID } from '../TrialBanner';
import { useError, useUpdated } from '@/utils/hooks/helpers';
import { OrgSettingsUpdatable } from '../../actions/updatable';
import { BaseUpdateOrgSettingsRequest, tryUpdateOrgSettings } from '../../actions/orgSettings';
import { useDispatch } from 'react-redux';

export const TrialActivation: React.FC<OrgComponentProps> = (props: OrgComponentProps) => {
    const dispatch = useDispatch();
    const isError = useError(OrgSettingsUpdatable.ActivateTrial);
    const isSuccess = useUpdated(OrgSettingsUpdatable.ActivateTrial);

    React.useEffect(() => {
        if (isError) {
            globalMessage.error(isError);
        }
    }, [isError]);

    React.useEffect(() => {
        if (isSuccess) {
            globalMessage.success('Trial activated!');
        }
    }, [isSuccess]);

    const activateTrial = (orgId: string) => {
        const request: BaseUpdateOrgSettingsRequest = {
            orgId: orgId,
        };
        dispatch(tryUpdateOrgSettings(OrgSettingsUpdatable.ActivateTrial, request));
    };

    React.useEffect(() => {
        // listen for trial activation userflow modal action, trigger trial activation
        userflow.on('flowEnded', (event) => {
            if (event.flow.id === USERFLOW_TRIAL_PROMPT_FLOW_ID && event.endReason === 'ACTION') {
                activateTrial(props.orgId);
            }
        });
    }, [props.orgId]);

    return null;
};

export default TrialActivation;
